import { SideBarNavGroupType } from "types/NavigationTypes";
import EnvironmentList from '../environments/EnvironmentList';
import DivisionList from '../environments/DivisionList';
import UserList from '../users/UserList';
import GroupList from '../users/GroupList';
import RoleList from '../users/RoleList';
import LabelList from './LabelList';
import TaskTypeList from './TaskTypeList';
import LedgerAccountList from './LedgerAccountList';
import VatRateList from './VatRateList';
import TimeBlockList from './scheduling/TimeBlockList';
import AttachmentTypeList from './AttachmentTypeList';
import JobTimeTypeList from './jobs/JobTimeTypeList';
import JobSettings from './jobs/JobSettings';
import ContractSettings from './contracts/ContractSettings';
import SchedulingSettings from './scheduling/SchedulingSettings';
import LayoutList from './LayoutList';
import ContactSettings from "./contacts/ContactSettings";
import TrialList from "../environments/TrialList";
import DemoEnvironmentList from "../environments/DemoEnvironmentList";
import InvoiceSettings from "./invoices/InvoiceSettings";
import ImportList from "./ImportList";
import ProposalSettings from "./proposals/ProposalSettings";
import PortalSettings from "./proposals/PortalSettings";
import DealSettings from "./deals/DealSettings";
import DealPipelineList from "./deals/DealPipelineList";
import DealSourceList from "./deals/DealSourceList";
import TicketSettings from "./tickets/TicketSettings";
import TicketCategoryList from "./tickets/TicketCategoryList";
import LostReasonList from "./deals/LostReasonList";
import OrderSettings from "./orders/OrderSettings";
import CompanyDetailsPage from "./CompanyDetailsPage";
import SchedulingBoardList from "./scheduling/SchedulingBoardList";
import InvoiceTypeList from "./invoices/InvoiceTypeList";
import JobTypeList from "./jobs/JobTypeList";
import ProposalTypeList from "./proposals/ProposalTypeList";
import OrderTypeList from "./orders/OrderTypeList";
import ProposalPdfLayoutList from "./proposals/ProposalPdfLayoutList";
import OrderPdfLayoutList from "./orders/OrderPdfLayoutList";
import JobPdfLayoutList from "./jobs/JobPdfLayoutList";
import InvoicePdfLayoutList from "./invoices/InvoicePdfLayoutList";
import BillingOverview from "./billing/billing-overview/BillingOverview";
import TimeSheetSettings from "./timesheets/TimeSheetSettings";
import TimeSheetTimeTypeList from "./timesheets/TimeSheetTimeTypeList";
import OtherActivitiesList from "./scheduling/OtherActivitiesList";
import WorkerPairList from "./scheduling/WorkerPairList";
import JobAppSettings from "./jobs/JobAppSettings";
import BillingInvoiceList from "./billing/billing-overview/BillingInvoiceList";
import SubscriptionPackageList from "./billing/subscription-packages/SubscriptionPackageList";
import ModulePriceList from "./billing/subscription-packages/ModulePriceList";
import PriceIndexationList from "./billing/subscription-packages/PriceIndexationList";
import ImplementationPackageList from "./billing/subscription-packages/ImplementationPackageList";
import EmailTemplateList from "./email/EmailTemplateList";
import EmailSettings from "./email/EmailSettings";
import ReleaseList from "../../views/releases/ReleaseList";
import EmailDomeinList from "./email/EmailDomainList";
import EmailLayoutList from "./email/EmailLayoutList";
import SmsSettings from "./sms/SmsSettings";
import SubcontractorSettings from "../../views/subcontractors/SubcontractorSettings";
import SubcontractorUsageList from "../../views/subcontractors/SubcontractorUsageList";
import SubscriptionPlans from "../../views/environments/SubscriptionPlans";
import SubscriptionList from "../../views/environments/SubscriptionList";
import BillingPlanningList from "../../views/environments/BillingPlanningList";
import ApiKeyList from "./api/ApiKeyList";
import ProjectTypeList from "./projects/ProjectTypeList";
import ProjectSettings from "./projects/ProjectSettings";
import IntegrationsLibraryPage from "./integrations/IntegrationsLibraryPage";
import PurchaseSettings from "./purchases/PurchaseSettings";
import CustomFieldList from "./customFields/CustomFieldList";
import CustomFieldUsageCounter from "./customFields/CustomFieldUsageCounter";
import FormTemplateList from "../forms/FormTemplateList";
import AssetTypeList from "./assets/AssetTypeList";
import FormList from "../forms/FormList";
import SecuritySettings from "./security/SecuritySettings";
import MaintenanceActions from "../maintenance/MaintenanceActions";
import KnowledgeBaseAdminPage from "./knowledge_base/KnowledgeBaseAdminPage";

// Map the component names to the actual components
export const componentMapping = {
    'EnvironmentList': EnvironmentList,
    'MaintenanceActions': MaintenanceActions,
    'KnowledgeBaseAdminPage': KnowledgeBaseAdminPage,
    'ReleaseList': ReleaseList,
    'TrialList': TrialList,
    'DemoEnvironmentList': DemoEnvironmentList,
    'SubscriptionList': SubscriptionList,
    'BillingPlanningList': BillingPlanningList,
    'SubscriptionPlans': SubscriptionPlans,
    'SubscriptionPackageList': SubscriptionPackageList,
    'ModulePriceList': ModulePriceList,
    'PriceIndexationList': PriceIndexationList,
    'ImplementationPackageList': ImplementationPackageList,
    'CompanySettings': CompanyDetailsPage,
    'DivisionList': DivisionList,
    'SchedulingSettings': SchedulingSettings,
    'SchedulingBoardList': SchedulingBoardList,
    'OtherActivitiesList': OtherActivitiesList,
    'WorkerPairList': WorkerPairList,
    'TimeBlockList': TimeBlockList,
    'JobSettings': JobSettings,
    'ContractSettings': ContractSettings,
    'JobAppSettings': JobAppSettings,
    'JobTypeList': JobTypeList,
    'JobTimeTypeList': JobTimeTypeList,
    'JobPdfLayoutList': JobPdfLayoutList,
    'TimeSheetSettings': TimeSheetSettings,
    'TimeSheetTimeTypeList': TimeSheetTimeTypeList,
    'ProjectSettings': ProjectSettings,
    'ProjectTypeList': ProjectTypeList,
    'InvoiceSettings': InvoiceSettings,
    'InvoiceTypeList': InvoiceTypeList,
    'InvoicePdfLayoutList': InvoicePdfLayoutList,
    'EmailSettings': EmailSettings,
    'EmailDomainList': EmailDomeinList,
    'EmailTemplateList': EmailTemplateList,
    'EmailLayoutList': EmailLayoutList,
    'SmsSettings': SmsSettings,
    'SubcontractorSettings': SubcontractorSettings,
    'SubcontractorUsageList': SubcontractorUsageList,
    'ContactSettings': ContactSettings,
    'AssetTypeList': AssetTypeList,
    'UserList': UserList,
    'GroupList': GroupList,
    'RoleList': RoleList,
    'SecuritySettings': SecuritySettings,
    'LabelList': LabelList,
    'LayoutList': LayoutList,
    'TaskTypeList': TaskTypeList,
    'CustomFieldList': CustomFieldList,
    'CustomFieldUsageCounter': CustomFieldUsageCounter,
    'FormList': FormList,
    'FormTemplateList': FormTemplateList,
    'AttachmentTypeList': AttachmentTypeList,
    'LedgerAccountList': LedgerAccountList,
    'VatRatesList': VatRateList,
    'ImportList': ImportList,
    'ProposalSettings': ProposalSettings,
    'PortalSettings': PortalSettings,
    'ProposalTypeList': ProposalTypeList,
    'ProposalPdfLayoutList': ProposalPdfLayoutList,
    'OrderSettings': OrderSettings,
    'OrderTypeList': OrderTypeList,
    'OrderPdfLayoutList': OrderPdfLayoutList,
    'PurchaseSettings': PurchaseSettings,
    'DealSettings': DealSettings,
    'DealPipelineList': DealPipelineList,
    'DealSourceList': DealSourceList,
    'TicketSettings': TicketSettings,
    'TicketCategoryList': TicketCategoryList,
    'LostReasonList': LostReasonList,
    'BillingOverview': BillingOverview,
    'BillingInvoiceList': BillingInvoiceList,
    'IntegrationsLibraryPage': IntegrationsLibraryPage,
    'ApiKeyList': ApiKeyList
}

// Define the settings menu items here
export const settingsConfig: { [groupName: string]: SideBarNavGroupType } = {
    admin: {
        label: "nav.admin_label",
        permissionCheck: ["no_user", "staff_user"],
        items: [
            {
                label: "nav.environments_label",
                route: "/settings/admin/environments",
                pageHeader: [
                    {
                        title: "nav.manage_environments_title",
                        tabs: [
                            { 
                                label: "nav.environments_tab",
                                path: 'environments',
                                componentName: "EnvironmentList",
                            },
                            { 
                                label: "nav.demo_environments_tab",
                                path: 'demo',
                                componentName: "DemoEnvironmentList",
                            },
                            { 
                                label: "nav.trials_tab",
                                path: 'trials',
                                componentName: "TrialList",
                            },
                            { 
                                label: "nav.subscriptions_tab",
                                path: 'subscriptions',
                                componentName: "SubscriptionList",
                            },
                            { 
                                label: "nav.billing_planning_tab",
                                path: 'billing',
                                componentName: "BillingPlanningList",
                                permissionCheck: "no_user",
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.packages_tab",
                route: "/settings/admin/plans",
                permissionCheck: "no_user",
                pageHeader: [
                    {
                        title: "nav.manage_packages_label",
                        tabs: [
                            { 
                                label: "nav.packages_overview_tab",
                                path: 'plans',
                                componentName: "SubscriptionPlans",
                            },
                            { 
                                label: "nav.subscription_package_tab",
                                path: 'packages',
                                componentName: "SubscriptionPackageList",
                            },
                            {
                                label: "nav.module_price_tab",
                                path: 'modules',
                                componentName: "ModulePriceList",
                            },
                            {
                                label: "nav.implementation_package_tab",
                                path: 'implementation',
                                componentName: "ImplementationPackageList",
                            },
                            {
                                label: "nav.price_indexation_tab",
                                path: 'indexations',
                                componentName: "PriceIndexationList",
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.release_label",
                route: "/settings/admin/releases",
                pageHeader: [
                    {
                        title: "nav.release_label",
                        tabs: [
                            {
                                label: "nav.release_label",
                                path: 'releases',
                                componentName: "ReleaseList",
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.maintenance_label",
                route: "/settings/admin/maintenance",
                permissionCheck: "no_user",
                pageHeader: [
                    {
                        title: "nav.maintenance_label",
                        tabs: [
                            {
                                label: "nav.maintenance_label",
                                path: 'actions',
                                componentName: "MaintenanceActions",
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.knowledge_base_label",
                route: "/settings/admin/knowledge-base",
                pageHeader: [
                    {
                        title: "nav.knowledge_base_label",
                        tabs: [
                            {
                                label: "nav.knowledge_base_label",
                                path: 'knowledge-base',
                                componentName: "KnowledgeBaseAdminPage",
                            },
                        ]
                    },
                ]
            },
        ]
    },
    general: {
        label: "nav.general_label",
        items: [
            {
                label: "nav.company_details_label",
                route: "/settings/general/company-details", 
                pageHeader: [
                    {
                        title: "nav.company_details_label",
                        explanationText: "nav.company_details_explanation",
                        tabs: [
                            {
                                label: "nav.company_details_label",
                                path: 'company-settings',
                                componentName: "CompanySettings",
                            }
                        ]
                    },
                ]               
            },
            {
                label: "nav.divisions_label",
                route: "/settings/general/divisions",
                requiredFeature: "divisions",
                environmentWide: true,
                pageHeader: [
                    {
                        title: "nav.divisions_title",
                        switchButton: true,
                        requiredFeature: "divisions",
                        explanationText: "nav.divisions_explanation",
                        tabs: [
                            {
                                label: "nav.divisions_label",
                                path: 'divisions',
                                componentName: "DivisionList",
                            }
                        ]
                    },
                ]
            },
            {
                label: "nav.users_label",
                route: "/settings/general/users",
                pageHeader: [
                    {
                        title: "nav.manage_users_title",
                        explanationText: "nav.users_explanation",
                        tabs: [
                            {
                                label: "nav.users_label",
                                path: 'users',
                                componentName: "UserList",
                            },
                            {
                                label: "nav.groups_label",
                                path: 'groups',
                                componentName: "GroupList",
                                activeFeature: "groups",
                                globalList: true,
                            },
                            {
                                label: "nav.roles_label",
                                path: 'roles',
                                componentName: "RoleList",
                                globalList: true,
                            },
                        ]
                    }
                ]
            },
            {
                label: "nav.subcontractors_label",
                route: "/settings/general/subcontractors",
                requiredFeature: "subcontractors",
                pageHeader: [
                    {
                        title: "nav.subcontractors_title",
                        switchButton: true,
                        requiredFeature: "subcontractors",
                        explanationText: "nav.subcontractors_menu_explanation",
                        tabs: [
                            {
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "SubcontractorSettings",
                            },
                            {
                                label: "subcontractor.day_pass.usage_tab_label",
                                path: 'usage',
                                componentName: "SubcontractorUsageList",
                                globalList: true,
                            },
                        ]
                    }
                ]
            },
            {
                label: "nav.security_label",
                route: "/settings/general/security",
                requiredFeature: "enhanced_security",
                pageHeader: [
                    {
                        title: "nav.security_title",
                        explanationText: "nav.security_explanation",
                        tabs: [
                            {
                                label: "nav.security_label",
                                path: 'security',
                                componentName: "SecuritySettings",
                                globalList: true,
                            },
                        ]
                    }
                ]
            },
        ]
    },
    features: {
        label: "nav.features_label",
        items: [
            {
                label: "nav.scheduling_label",
                route: "/settings/features/scheduling",
                requiredFeature: 'scheduling',
                showWhenDisabled: true,
                pageHeader: [
                    {
                        title: "nav.scheduling_title",
                        switchButton: true,
                        requiredFeature: "scheduling",
                        explanationText: "nav.scheduling_explanation",
                        tabs: [
                            { 
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "SchedulingSettings",
                            },
                            {
                                label: "nav.scheduling_boards",
                                path: 'scheduling-boards',
                                componentName: "SchedulingBoardList",
                                globalList: true,
                            },
                            {
                                label: "nav.other_activities_label",
                                path: 'other-activities',
                                componentName: "OtherActivitiesList",
                                globalList: true,
                            },
                            {
                                label: "nav.worker_pairs_label",
                                path: 'worker-pairs',
                                componentName: "WorkerPairList",
                                activeFeature: 'worker_pairs',
                                globalList: true,
                            },
                            // {
                            //     label: "nav.time_blocks_label",
                            //     componentName: "TimeBlockList",
                            //     // activeFeature: 'scheduling_time_blocks'
                            // },
                        ]
                    },
                ]
            },
            {
                label: "nav.jobs_label",
                route: "/settings/features/jobs",
                requiredFeature: 'jobs',
                showWhenDisabled: true,
                pageHeader: [
                    {
                        title: "nav.jobs_label",
                        switchButton: true,
                        requiredFeature: "jobs",
                        explanationText: "nav.jobs_explanation",
                        tabs: [
                            { 
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "JobSettings",
                            },
                            { 
                                label: "nav.jobs_app_settings_label",
                                path: 'app-settings',
                                componentName: "JobAppSettings",
                            },
                            {
                                label: "nav.jobs_type_label",
                                path: 'job-types',
                                componentName: "JobTypeList",
                                activeFeature: 'job_types',
                            },
                            {
                                label: "nav.jobs_timetype_label",
                                path: 'time-types',
                                componentName: "JobTimeTypeList",
                                globalList: true,
                            },
                            {
                                label: "nav.pdf_layout_list_label",
                                path: 'pdf-layouts',
                                componentName: "JobPdfLayoutList",
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.contracts_label",
                route: "/settings/features/contracts",
                requiredFeature: 'contract_management',
                pageHeader: [
                    {
                        title: "nav.contracts_label",
                        switchButton: true,
                        requiredFeature: "contract_management",
                        explanationText: "nav.contract_management_explanation",
                        tabs: [
                            {
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "ContractSettings",
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.timesheets_label",
                route: "/settings/features/timesheets",
                requiredFeature: 'manage_timesheets',
                pageHeader: [
                    {
                        title: "nav.timesheets_label",
                        switchButton: true,
                        requiredFeature: "manage_timesheets",
                        explanationText: "nav.timesheets_explanation",
                        tabs: [
                            {
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "TimeSheetSettings",
                            },
                            {
                                label: "nav.timesheets_timetype_label",
                                path: 'time-types',
                                componentName: "TimeSheetTimeTypeList",
                                globalList: true,
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.projects_label",
                route: "/settings/features/projects",
                requiredFeature: "projects",
                pageHeader: [
                    {
                        title: "nav.projects_label",
                        switchButton: true,
                        requiredFeature: "projects",
                        explanationText: "nav.projects_explanation",
                        tabs: [
                            {
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "ProjectSettings",
                                globalList: true,
                            },
                            {
                                label: "nav.projects_type_label",
                                path: 'project-types',
                                componentName: "ProjectTypeList",
                                globalList: true,
                            },
                        ]
                    },
                ]
            },
            // {
            //     label: "nav.mobile_app_label",
            //     route: "/settings/features/mobile-app",
            // },
            {
                label: "nav.deals_label",
                route: "/settings/features/deals",
                requiredFeature: 'deals',
                pageHeader: [
                    {
                        title: "nav.deals_label",
                        switchButton: true,
                        requiredFeature: "deals",
                        explanationText: "nav.deals_explanation",
                        tabs: [
                            {
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "DealSettings",
                            },
                            { 
                                label: "nav.deal_pipelines_label",
                                path: 'pipelines',
                                componentName: "DealPipelineList",
                                globalList: true,
                            },
                            { 
                                label: "nav.deal_sources_label",
                                path: 'sources',
                                componentName: "DealSourceList",
                                globalList: true,
                            },
                            { 
                                label: "nav.deal_lost_reasons_label",
                                path: 'lost-reasons',
                                componentName: "LostReasonList",
                                globalList: true,
                            }
                        ]
                    },
                ]
            },
            {
                label: "nav.proposals_label",
                route: "/settings/features/proposals",
                requiredFeature: 'proposals',
                showWhenDisabled: true,
                pageHeader: [
                    {
                        title: "nav.proposals_label",
                        switchButton: true,
                        requiredFeature: "proposals",
                        explanationText: "nav.proposals_explanation",
                        tabs: [
                            {
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "ProposalSettings",
                                globalList: true,
                            },
                            {
                                label: "nav.proposals_type_label",
                                path: 'proposal-types',
                                componentName: "ProposalTypeList",
                                globalList: true,
                            },
                            {
                                label: "nav.pdf_layout_list_label",
                                path: 'pdf-layouts',
                                componentName: "ProposalPdfLayoutList",
                            },
                            {
                                label: "nav.proposal_portal_label",
                                path: 'signing-settings',
                                componentName: "PortalSettings",
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.orders_label",
                route: "/settings/features/orders",
                requiredFeature: 'orders',
                pageHeader: [
                    {
                        title: "nav.orders_label",
                        switchButton: true,
                        requiredFeature: "orders",
                        explanationText: "nav.orders_explanation",
                        tabs: [
                            {
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "OrderSettings",
                                globalList: true,
                            },
                            {
                                label: "nav.orders_type_label",
                                path: 'order-types',
                                componentName: "OrderTypeList",
                                globalList: true,
                            },
                            {
                                label: "nav.pdf_layout_list_label",
                                path: 'pdf-layouts',
                                componentName: "OrderPdfLayoutList",
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.purchases_label",
                route: "/settings/features/purchases",
                requiredFeature: 'purchases',
                pageHeader: [
                    {
                        title: "nav.purchases_label",
                        switchButton: true,
                        requiredFeature: "purchases",
                        explanationText: "nav.purchases_explanation",
                        tabs: [
                            { 
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "PurchaseSettings",
                                globalList: true,
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.invoices_label",
                route: "/settings/features/invoices",
                requiredFeature: 'invoices',
                showWhenDisabled: true,
                pageHeader: [
                    {
                        title: "nav.invoices_label",
                        switchButton: true,
                        requiredFeature: "invoices",
                        explanationText: "nav.invoices_explanation",
                        tabs: [
                            { 
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "InvoiceSettings",
                            },
                            {
                                label: "nav.invoice_type_label",
                                path: 'invoice-types',
                                componentName: "InvoiceTypeList",
                                globalList: true,
                            },
                            {
                                label: "nav.pdf_layout_list_label",
                                path: 'pdf-layouts',
                                componentName: "InvoicePdfLayoutList",
                            }
                        ]
                    },
                ]
            },
            {
                label: "nav.email_label",
                route: "/settings/features/email",
                pageHeader: [
                    {
                        title: "nav.email_label",
                        explanationText: "nav.email_explanation",
                        tabs: [
                            { 
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "EmailSettings",
                            },
                            {
                                label: "nav.email_templates_label",
                                path: 'email-templates',
                                componentName: "EmailTemplateList",
                            },
                            {
                                label: "nav.email_layouts_label",
                                path: 'email-layouts',
                                componentName: "EmailLayoutList",
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.sms_label",
                route: "/settings/features/sms",
                requiredFeature: "sms_reminders",
                pageHeader: [
                    {
                        title: "nav.sms_label",
                        switchButton: true,
                        requiredFeature: "sms_reminders",
                        explanationText: "nav.sms_explanation",
                        tabs: [
                            {
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "SmsSettings",
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.contacts_label",
                route: "/settings/features/contacts",
                pageHeader: [
                    {
                        title: "nav.contacts_label",
                        explanationText: "nav.contacts_explanation",
                        tabs: [
                            { 
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "ContactSettings",
                            }
                        ]
                    },
                ]
            },
            {
                label: "nav.asset_management_title",
                route: "/settings/features/assets",
                requiredFeature: 'asset_management',
                pageHeader: [
                    {
                        title: "nav.asset_management_title",
                        switchButton: true,
                        requiredFeature: "asset_management",
                        explanationText: "nav.asset_management_explanation",
                        tabs: [
                            { 
                                label: "nav.asset_types_label",
                                path: 'asset-types',
                                componentName: "AssetTypeList",
                                globalList: true,
                            },
                            {
                                label: "nav.asset_info_pages_label",
                                path: 'info-pages',
                                componentName: "CustomFieldList",
                                globalList: true,
                                componentProps: { objectType: "asset_type" },
                            },
                            {
                                label: "nav.asset_inspection_fields_label",
                                path: 'inspection-fields',
                                componentName: "CustomFieldList",
                                globalList: true,
                                componentProps: { objectType: "asset_type_inspection" },
                                activeFeature: 'forms_extended',
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.tickets_label",
                route: "/settings/features/tickets",
                requiredFeature: 'tickets',
                pageHeader: [
                    {
                        title: "nav.tickets_label",
                        switchButton: true,
                        requiredFeature: "tickets",
                        explanationText: "nav.tickets_explanation",
                        tabs: [
                            {
                                label: "nav.settings_label",
                                path: 'settings',
                                componentName: "TicketSettings",
                            },
                            {
                                label: "ticket.category.categories_label",
                                path: 'categories',
                                componentName: "TicketCategoryList",
                                globalList: true,
                            },
                        ]
                    },
                ]
            },
            {
                label: "nav.reporting_label",
                route: "/settings/features/reporting",
                requiredFeature: "reporting",
                environmentWide: true,
                pageHeader: [
                    {
                        title: "nav.reporting_label",
                        switchButton: true,
                        requiredFeature: "reporting",
                        explanationText: "nav.reporting_explanation",
                        tabs: [
                            {
                                label: "",
                                componentName: "",
                            }
                        ]
                    },
                ]
            },
            {
                label: "nav.additional_modules_label",
                route: "/settings/features/additional-modules",
                environmentWide: true,
                pageHeader: [
                    {
                        title: "nav.subcontractors_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.subcontractors_explanation",
                        requiredFeature: "subcontractors",
                    },
                    {
                        title: "nav.inventory_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.inventory_explanation",
                        requiredFeature: "inventory",
                    },
                    {
                        title: "nav.inbox_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.inbox_explanation",
                        requiredFeature: "inbox",
                    },
                    {
                        title: "nav.objects_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.objects_explanation",
                        requiredFeature: "location_objects",
                    },
                    {
                        title: "nav.client_portal_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.client_portal_explanation",
                        requiredFeature: "client_portal",
                    },
                    {
                        title: "nav.custom_roles_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.custom_roles_explanation",
                        requiredFeature: "custom_roles",
                    },
                    {
                        title: "nav.contract_management_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.contract_management_explanation",
                        requiredFeature: "contract_management",
                    },
                    {
                        title: "nav.asset_management_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.asset_management_explanation",
                        requiredFeature: "asset_management",
                    },
                    {
                        title: "nav.newsletters_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.newsletters_explanation",
                        requiredFeature: "newsletters",
                    },
                    {
                        title: "nav.deals_label",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.deals_explanation",
                        requiredFeature: "deals",
                    },
                    {
                        title: "nav.projects_label",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.projects_explanation",
                        requiredFeature: "projects",
                    },
                    {
                        title: "nav.orders_label",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.orders_explanation",
                        requiredFeature: "orders",
                    },
                    {
                        title: "nav.purchases_label",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.purchases_explanation",
                        requiredFeature: "purchases",
                    },
                    // {
                    //     title: "nav.workflows_title",
                    //     switchButton: true,
                    //     moduleCard: true,
                    //     explanationText: "nav.workflows_explanation",
                    //     requiredFeature: "workflows",
                    // },
                    {
                        title: "nav.servicedesk_tickets_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.servicedesk_tickets_explanation",
                        requiredFeature: "tickets",
                    },
                    {
                        title: "nav.hrm_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.hrm_explanation",
                        requiredFeature: "hrm",
                    },
                    {
                        title: "nav.appointment_booking_engine_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.appointment_booking_engine_explanation",
                        requiredFeature: "appointment_booking_engine",
                    },
                    {
                        title: "nav.divisions_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.divisions_explanation",
                        requiredFeature: "divisions",
                    },
                    {
                        title: "nav.reporting_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.reporting_explanation",
                        requiredFeature: "reporting",
                    },
                    {
                        title: "nav.gps_tracking_title",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.gps_tracking_explanation",
                        requiredFeature: "mobile_gps_tracking",
                    },
                    {
                        title: "nav.sms_label",
                        switchButton: true,
                        moduleCard: true,
                        explanationText: "nav.sms_explanation",
                        requiredFeature: "sms_reminders",
                    },
                ]
            }
        ]
    },
    custom_fields: {
        label: "nav.custom_fields_label",
        items: [
            {
                label: "nav.labels_label",
                route: "/settings/custom-fields/labels",
                pageHeader: [
                    {
                        title: "nav.labels_label",
                        explanationText: "nav.labels_explanation",
                        tabs: [
                            {
                                label: "nav.labels_label",
                                path: 'labels',
                                componentName: "LabelList",
                                globalList: true,
                            }
                        ]
                    },
                ]
            },
            {
                label: "nav.categories_label",
                route: "/settings/custom-fields/categories",
                pageHeader: [
                    {
                        title: "nav.categories_label",
                        explanationText: "nav.categories_explanation",
                        tabs: [
                            { 
                                label: "nav.task_type_label", 
                                path: 'task-types',
                                componentName: "TaskTypeList",
                                globalList: true,
                            },
                            { 
                                label: "nav.attachment_type_label", 
                                path: 'attachment-types',
                                componentName: "AttachmentTypeList",
                                globalList: true,
                            },
                            { 
                                label: "nav.ledger_account_label", 
                                path: 'ledger-accounts',
                                componentName: "LedgerAccountList",
                                globalList: true,
                            },
                            { 
                                label: "nav.vat_rates_label", 
                                path: 'vat-rates',
                                componentName: "VatRatesList",
                                globalList: true,
                            },
                        ]
                    }
                ]
            },
            { 
                label: "nav.custom_fields_label",
                route: "/settings/custom-fields/fields",
                requiredFeature: 'custom_fields_base',
                pageHeader: [
                    {
                        title: "nav.custom_fields_label",
                        explanationText: "nav.custom_fields_explanation",
                        counterComponentName: "CustomFieldUsageCounter",
                        tabs: [
                            {
                                label: "nav.jobs_label",
                                path: 'jobs',
                                componentName: "CustomFieldList",
                                globalList: true,
                                componentProps: { objectType: "job_workflow" },
                            },
                            // {
                            //     label: "nav.appointments_label",
                            //     path: 'appointments',
                            //     componentName: "CustomFieldList",
                            //     componentProps: { objectType: "job_workflow_appointment" },
                            // },
                            {
                                label: "nav.contacts_label",
                                path: 'contacts',
                                componentName: "CustomFieldList",
                                globalList: true,
                                componentProps: { objectType: "contact_entity_type" },
                            },
                            // {
                            //     label: "nav.products_label",
                            //     path: 'products',
                            //     componentName: "CustomFieldList",
                            //     componentProps: { objectType: "product_category" },
                            // },
                            {
                                label: "nav.deals_label",
                                path: 'deals',
                                componentName: "CustomFieldList",
                                globalList: true,
                                componentProps: { objectType: "deal_pipeline" },
                                activeFeature: "deals",
                            }
                        ]
                    },
                ]
            },
            { 
                label: "nav.forms_label",
                route: "/settings/custom-fields/forms",
                requiredFeature: 'forms_base',
                pageHeader: [
                    {
                        title: "nav.forms_label",
                        explanationText: "nav.forms_explanation",
                        tabs: [
                            {
                                label: "nav.forms_label",
                                path: 'forms',
                                componentName: "FormList",
                                globalList: true,
                                activeFeature: 'forms_base'
                            },
                            {
                                label: "nav.form_templates_label",
                                path: 'form-templates',
                                componentName: "FormTemplateList",
                                globalList: true,
                                activeFeature: 'forms_extended'
                            }
                        ]
                    },
                ]
            },
            {
                label: "nav.imports_label",
                route: "/settings/custom-fields/data-imports",
                pageHeader: [
                    {
                        title: "nav.imports_label",
                        explanationText: "nav.imports_explanation",
                        tabs: [
                            {
                                label: "nav.imports_label",
                                path: 'imports',
                                componentName: "ImportList",
                                globalList: true,
                            }
                        ]
                    },
                ]
            },
        ]
    },
    // templates: {
    //     label: "nav.templates_label",
    //     items: [
    //         { 
    //             label: "nav.layouts_label", 
    //             route: "/settings/templates/layouts",
    //             pageHeader: [
    //                 {
    //                     title: "nav.layouts_label",
    //                     explanationText: "nav.layouts_explanation",
    //                     tabs: [
    //                         {
    //                             label: "nav.layouts_label",
    //                             path: 'layouts',
    //                             componentName: "LayoutList",
    //                         }
    //                     ]
    //                 },
    //             ]
    //         },
    //     ]
    // },
    integrations: {
        label: "nav.integrations_label",
        items: [
            // { label: "nav.calendar_integration_label", route: "/settings/integrations/calendar" },
            // { label: "nav.email_integration_label", route: "/settings/integrations/email-integration" },
            { 
                label: "nav.integrations_library_label",
                route: "/settings/integrations/integrations-library",
                pageHeader: [
                    {
                        title: "nav.integrations_library_label",
                        explanationText: "nav.integrations_library_explanation",
                        tabs: [
                            {
                                componentName: "IntegrationsLibraryPage",
                                globalList: true,
                            }
                        ]
                    },
                ]
            },
            { 
                label: "nav.api_keys_label",
                route: "/settings/integrations/api-keys",
                hideForViewOnlyPackage: true,
                pageHeader: [
                    {
                        title: "nav.api_keys_label",
                        explanationText: "nav.api_keys_explanation",
                        tabs: [
                            {
                                label: "nav.api_keys_label",
                                componentName: "ApiKeyList",
                            }
                        ]
                    },
                ]
            },
        ]
    },
    billing: {
        label: "nav.billing_label",
        hideForEnvironmentType: ['admin', 'beta', 'api-partner'],
        items: [
            { 
                label: "nav.plan_label",
                route: "/settings/billing/subscription",
                environmentWide: true,
                pageHeader: [
                    {
                        title: "nav.billing_label",
                        tabs: [
                            {
                                label: "nav.subscription",
                                componentName: "BillingOverview",
                            }
                        ]
                    },
                ]
            },
            { 
                label: "nav.payments_label",
                route: "/settings/billing/invoices",
                environmentWide: true,
                pageHeader: [
                    {
                        title: "nav.payments_label",
                        tabs: [
                            {
                                label: "nav.payments_label",
                                componentName: "BillingInvoiceList",
                            }
                        ]
                    },
                ]
            },
        ]
    }
}    